module.exports = __webpack_public_path__ + "img/front-facing-baby-chick.ca0727d5.png";